import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";
import { PackagedBeerDetailsContainer } from "../../../../gql/hooks";

type SetProductsOrderParams = {
  productId: number;
  type: PackagedBeerDetailsContainer;
  isAdding: boolean;
};

function SetProductsOrderReducer(
  state: ProposalState,
  {
    payload: { productId, type, isAdding },
  }: PayloadAction<SetProductsOrderParams>,
) {
  if (!state.productOrdered) {
    state.productOrdered = [];
  }
  const find = state.productOrdered.find(
    (product) => product.id === productId && product.type === type,
  );
  if (find && !isAdding) {
    state.productOrdered = state.productOrdered.filter(
      (product) => !(product.id === productId && product.type === type),
    );
  } else {
    state.productOrdered.push({ id: productId, type });
  }
}

type SetInitProductsOrderParams = {
  id: number;
  type: PackagedBeerDetailsContainer;
}[];

function SetInitProductsOrderReducer(
  state: ProposalState,
  { payload: products }: PayloadAction<SetInitProductsOrderParams>,
) {
  state.productOrdered = products;
}

type SetInitProductsOrderFormIdParams = {
  index: number;
  formId: string;
};

const SetProductsOrderFormIdReducer = (
  state: ProposalState,
  {
    payload: { index, formId },
  }: PayloadAction<SetInitProductsOrderFormIdParams>,
) => {
  if (state.productOrdered && state.productOrdered[index]) {
    state.productOrdered[index].formId = formId;
  }
};

type SetProductOrderChangeParams = {
  index: number;
  formId: string;
};

const SetProductOrderChangeReducer = (
  state: ProposalState,
  { payload: { formId, index } }: PayloadAction<SetProductOrderChangeParams>,
) => {
  if (!state.productOrdered) return;
  const currentIndex = state.productOrdered.findIndex(
    (item) => item.formId === formId,
  );

  if (currentIndex > -1) {
    const updated = [...state.productOrdered];
    const [item] = updated.splice(currentIndex, 1);
    updated.splice(index, 0, item);
    state.productOrdered = updated;
  }
};

export {
  SetProductsOrderReducer,
  SetInitProductsOrderReducer,
  SetProductOrderChangeReducer,
  SetProductsOrderFormIdReducer,
};
